import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { IPromoCard } from '@models/IPromoCard';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

const PromoCard = ({
  title,
  text,
  cta,
  image,
  isLargeCard,
  dataTestId = 'Promo-Card',
}: IPromoCard) => {
  const isMobile = useMediaQuery(1440);

  return (
    <div
      className={classNames(
        'justify-between items-center relative h-full w-full flex flex-col gap-13 text-white px-4 pt-4 bg-grey-600 rounded-[10px]',
        isLargeCard ? 'xl:pb-[96px] pb-13' : 'pb-13'
      )}
      data-testid={dataTestId}
    >
      {image && (
        <Image
          image={image}
          classes="w-full"
          imageClasses="w-full object-contain rounded-[10px]"
          dataTestId={`${dataTestId}-Image`}
        />
      )}
      <div
        className={classNames(
          'flex flex-col justify-center items-center w-[85%]',
          isLargeCard ? 'lg:gap-7.5 gap-4' : 'gap-5'
        )}
      >
        <div
          className={classNames(
            'flex flex-col',
            isLargeCard ? 'gap-4 lg:gap-7.5' : 'gap-2.5'
          )}
        >
          <p
            className={classNames(
              'text-center',
              isMobile || !isLargeCard ? 'h5' : 'h3'
            )}
            data-testid={`${dataTestId}-Title`}
          >
            {title}
          </p>
          {text && (
            <p
              className="body-one text-center"
              data-testid={`${dataTestId}-Text`}
            >
              {text}
            </p>
          )}
        </div>
        {cta?.url && cta.name && (
          <Button link={cta} dataTestId={`${dataTestId}-Link`} />
        )}
      </div>
    </div>
  );
};

export default PromoCard;
